import { ParlorDetailProps } from "@/types/parlor";
import { FUNERAL_SIDO, FUNERAL_SIGUNGU, getCdnImageSrc } from "goi_common";
import { 고이_상품_가격_세자리 } from "../servicePackageDetails";

const reviewResult76 = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "포항국화원장례식장",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "0.0",
    bestRating: "5",
    ratingCount: "5",
  },
  review: [
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "영**",
      },
      reviewBody:
        "분리수거하지않는 모습이  많이걸리네요   음료수캔과 물병을  찌꺼기묻은  일회용품들과  같이버리고~~사무실직원분께서는  그냥버려도괜찮다하시고           화장실이  너무어둡고  비대가없어요",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "1",
      },
    },
  ],
};

const howtoRichSearch = (defaultParlor: ParlorDetailProps) => {
  return {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: `${FUNERAL_SIDO.get(Number(defaultParlor.sido)) as string} 지역 ${`${
      FUNERAL_SIGUNGU.get(Number(defaultParlor.sido))?.get(Number(defaultParlor.sigungu)) as string
    }`}장례식장, 잘 고르는 방법.(${defaultParlor.companyname})`,
    image: {
      "@type": "ImageObject",
      url: defaultParlor?.images[0]?.url || `${process.env.NEXT_PUBLIC_CDN_URL}/ogimage.png`,
      height: "305",
      width: "406",
    },
    estimatedCost: {
      "@type": "MonetaryAmount",
      currency: "KRW",
      value: defaultParlor.expected_charge_sum.가족장,
    },
    video: {
      "@type": "VideoObject",
      name: "장례식장 비용 알아보기",
      description:
        "장례식장을 이용할 때 비용이 얼마나 드는지에 대해 알려 드리고자 합니다. 자세한 내용은 영상을 통해 확인하실 수 있습니다.",
      contentUrl: "https://www.youtube.com/watch?v=sb3EF2aE1C4",
      embedUrl: "https://www.youtube.com/watch?v=sb3EF2aE1C4",
      thumbnailUrl: "https://img.youtube.com/vi/sb3EF2aE1C4/0.jpg",
      uploadDate: "2023-08-18T08:00:00+08:00",
      duration: "PT245S",
      hasPart: [
        {
          "@type": "Clip",
          "@id": "Clip1",
          name: "염두에 두고 있는 장례식장의 위치, 품목별 비용 확인",
          startOffset: 0,
          endOffset: 300,
          url: "https://www.youtube.com/watch?v=sb3EF2aE1C4?t=0",
        },
        {
          "@type": "Clip",
          "@id": "Clip2",
          name: "장례식장 후기 확인",
          startOffset: 0,
          endOffset: 300,
          url: "https://www.youtube.com/watch?v=BgaaS2DSEcA?t=0",
        },
        {
          "@type": "Clip",
          "@id": "Clip3",
          name: "미리 상담받고 믿을 수 있는 장례지도사 고르기",
          startOffset: 0,
          endOffset: 245,
          url: "https://www.youtube.com/watch?v=y5I8YthjspI?t=0",
        },
        {
          "@type": "Clip",
          "@id": "Clip4",
          name: "온전히 추모에 집중하세요. 장례식장과의 논의, 전 과정은 장례지도사에게 맡겨주세요.",
          startOffset: 0,
          endOffset: 354,
          url: "https://www.youtube.com/watch?v=y5I8YthjspI?t=0",
        },
      ],
    },
    step: [
      {
        "@type": "HowToStep",
        url: "https://www.goifuneral.co.kr/match/request/",
        name: "염두에 두고 있는 장례식장의 위치, 품목별 비용 확인",
        itemListElement: [
          {
            "@type": "HowToDirection",
            text: "염두에 두고 있는 장례식장의 위치, 빈소 비용, 세부 품목별 비용을 확인하세요. 아직 고민중이라면 장례식장 비용 비교, 고이의 추천을 받아보세요.",
          },
          {
            "@type": "HowToDirection",
            text: "비용 변동이 있을 수 있으니 반드시 상담을 받으시길 바랍니다.",
          },
        ],
        image: {
          "@type": "ImageObject",
          url: "https://goifuneral.mo.cloudinary.net/images/guidebook/guidebook_info_2.png",
          height: "420",
          width: "368",
        },
        video: {
          "@type": "VideoObject",
          name: "장례식장의 종류와 비용,",
          description:
            "장례식장에도 여러 종류가 있다는 사실, 알고 계셨나요? 오늘은 장례식장의 종류에는 무엇이 있는지, 그리고 각 장례식장을 이용할 때 비용이 얼마나 드는지에 대해 알려 드리고자 합니다.자세한 내용은 영상을 통해 확인하실 수 있습니다.",
          contentUrl: "https://www.youtube.com/watch?v=sb3EF2aE1C4?t=0",
          embedUrl: "https://www.youtube.com/watch?v=sb3EF2aE1C4?t=0",
          thumbnailUrl: "https://img.youtube.com/vi/sb3EF2aE1C4/0.jpg",
          uploadDate: "2023-08-18T08:00:00+08:00",
          duration: "PT12S",
        },
      },
      {
        "@type": "HowToStep",
        url: `https://www.goifuneral.co.kr/parlor/${defaultParlor.id}/`,
        name: "장례식장 후기 확인",
        itemListElement: [
          {
            "@type": "HowToDirection",
            text: "장례식장의 후기를 찾아보세요. 경우에 따라 예상보다 더 큰 비용을 청구할수도 있고, 불편한 경험을 할 수 있습니다. 장례지도사와 미리 상담 받기를 추천드립니다.",
          },
        ],
        image: {
          "@type": "ImageObject",
          url: "https://goifuneral.mo.cloudinary.net/images/guidebook/tip/embed/before/1.png",
          height: "258",
          width: "430",
        },
        video: {
          "@type": "VideoObject",
          name: "고이 상주 인터뷰, 후기",
          description:
            "고이와 함께 부친상을 치르신 상주님의 사연입니다. 삼가 고인의 명복을 빕니다. 고이는 365일 24시간 오직 가족을 위한 장례 상담을 진행해드리고 있습니다",
          contentUrl: "https://www.youtube.com/watch?v=BgaaS2DSEcA",
          embedUrl: "https://www.youtube.com/watch?v=BgaaS2DSEcA",
          thumbnailUrl: "https://img.youtube.com/vi/BgaaS2DSEcA/0.jpg",
          uploadDate: "2023-08-18T08:00:00+08:00",
          duration: "PT12S",
        },
      },
      {
        "@type": "HowToStep",
        url: `https://www.goifuneral.co.kr/match/request`,
        name: "미리 상담받고 믿을 수 있는 장례지도사 고르기",
        itemListElement: [
          {
            "@type": "HowToDirection",
            text: "장례식장에서 직접 진행하는 경우, 비용 부담이 지나치게 커지거나 원치 않는 품목을 강요받을 수 있습니다.",
          },
          {
            "@type": "HowToDirection",
            text: "미리 장례지도사를 추천받아 장례식장과의 협상에서 우위를 점하여 예상치 못한 상황에 대처하고, 온전히 고인의 추모에 집중할 수 있도록 하세요.",
          },
        ],
        image: {
          "@type": "ImageObject",
          url: "https://goifuneral.mo.cloudinary.net/platform/funeralprepare/1/image2.png",
          height: "205",
          width: "342",
        },
        video: {
          "@type": "VideoObject",
          name: "고이 장례지도사 인터뷰 인터뷰",
          description: "아버님께 못다한 마음, 장례를 치르는 가족분들께 전해드리자 마음먹었습니다",
          contentUrl: "https://www.youtube.com/watch?v=y5I8YthjspI",
          embedUrl: "https://www.youtube.com/watch?v=y5I8YthjspI",
          thumbnailUrl: "https://img.youtube.com/vi/y5I8YthjspI/0.jpg",
          uploadDate: "2023-08-18T08:00:00+08:00",
          duration: "PT245S",
        },
      },

      {
        "@type": "HowToStep",
        url: `https://www.goifuneral.co.kr/review/`,
        name: "온전히 추모에 집중하세요. 장례식장과의 논의, 전 과정은 장례지도사에게 맡겨주세요.",
        itemListElement: [
          {
            "@type": "HowToDirection",
            text: "사전 장례식장 결정부터 갑작스러운 조문객 인원 변동, 장지까지 장례지도사가 함께하며 상주분들과 제 2의 가족이 되어드립니다.",
          },
        ],
        image: {
          "@type": "ImageObject",
          url: "https://goifuneral.mo.cloudinary.net/images/funeraldirector/3/square.png",
          height: "205",
          width: "342",
        },
        video: {
          "@type": "VideoObject",
          name: "고이와 상담하고 장례지도사에게 맡겨주세요",
          description: "고이의 실제 상담 내용을 직접 들어 보세요.",
          contentUrl: "https://www.youtube.com/watch?v=w0cv1pkOkVc",
          embedUrl: "https://www.youtube.com/watch?v=w0cv1pkOkVc",
          thumbnailUrl: "https://img.youtube.com/vi/w0cv1pkOkVc/0.jpg",
          uploadDate: "2023-08-18T08:00:00+08:00",
          duration: "PT245S",
        },
      },
    ],
    totalTime: "P7D",
  };
};

const carouselRichSearch = (defaultParlor: ParlorDetailProps) => {
  return {
    "@context": "http://schema.org",
    "@type": "ItemList",
    itemListElement: [
      {
        "@type": "ListItem",
        name: `${defaultParlor.companyname} 비용 알아보기`,
        image:
          defaultParlor.images && defaultParlor.images[0] && defaultParlor.images[0].url
            ? defaultParlor.images[0].url
            : "https://goifuneral.mo.cloudinary.net/platform/logo.svg",
        url: `https://www.goifuneral.co.kr/parlor/${defaultParlor.id}/`,
        position: "1",
      },
      {
        "@type": "ListItem",
        name: "장례준비가 처음이라면?",
        image: "https://goifuneral.mo.cloudinary.net/platform/prepare/prepare-1-1.png",
        url: `https://www.goifuneral.co.kr/funeral-prepare/1/`,
        position: "2",
      },
      {
        "@type": "ListItem",
        name: "장례식장, 음식비용 줄이기",
        image:
          "https://goifuneral.mo.cloudinary.net/platform/home/match-request-version/twemoji_balance-scale.png",
        url: `https://www.goifuneral.co.kr/funeral-prepare/funeral-cost/`,
        position: "3",
      },
      {
        "@type": "ListItem",
        name: "장례준비, 가장 먼저 알아볼 것은?",
        image: "https://goifuneral.mo.cloudinary.net/platform/prepare/prepare-1-1.png",
        url: `https://www.goifuneral.co.kr/funeral-prepare/1/`,
        position: "4",
      },
      {
        "@type": "ListItem",
        name: "장례식장 비용 비교",
        image:
          "https://goifuneral.mo.cloudinary.net/platform/home/match-request-version/twemoji_balance-scale.png",
        url: `https://www.goifuneral.co.kr/funeral-prepare/funeral-cost/`,
        position: "5",
      },
      {
        "@type": "ListItem",
        name: "장례식 총비용 알아보기",
        image: getCdnImageSrc("platform/parlor/1-no-extra-cost.png"),
        url: `https://www.goifuneral.co.kr/funeral-prepare/funeral-cost/`,
        position: "6",
      },
      {
        "@type": "ListItem",
        name: "고이장례연구소",
        image: "https://goifuneral.mo.cloudinary.net/logo.jpg",
        url: `https://www.goifuneral.co.kr/funeral-prepare/company-introduction/`,
        position: "7",
      },
      {
        "@type": "ListItem",
        name: "후불제상조 알아보기",
        image: "https://goifuneral.mo.cloudinary.net/platform/service/person2.png",
        url: `https://www.goifuneral.co.kr/funeral-prepare/2/`,
        position: "8",
      },
      {
        "@type": "ListItem",
        name: "후불제상조 비용",
        image: "https://goifuneral.mo.cloudinary.net/platform/service/person1.png",
        url: `https://www.goifuneral.co.kr/service/`,
        position: "9",
      },

      {
        "@type": "ListItem",
        name: `가족장 ${고이_상품_가격_세자리["가족장"]} 상세보기`,
        image: "https://goifuneral.mo.cloudinary.net/platform/service/person1.png",
        url: `https://www.goifuneral.co.kr/service/`,
        position: "10",
      },

      {
        "@type": "ListItem",
        name: "화환보내기",
        image: "https://goifuneral.mo.cloudinary.net/platform/parlor/flower5.png",
        url: `https://www.goifuneral.co.kr/service/flower`,
        position: "10",
      },
    ],
  };
};

const parlorFaqData = [
  {
    question:
      "빠르게 문의하기(1666-9784) | [임종시 행동요령] 임종하신 상황으로 실시간 빈소 현황, 지금 무엇부터 해야하는지(장례식장 이송 절차, 전체 장례 비용 등) 빠르게 알고싶어요.",
    answer:
      "<a href='https://www.goifuneral.co.kr/funeral-prepare/1/?utm_campaign=naver_faq'>장례가 처음이라면</a> | <a href='https://www.goifuneral.co.kr/match/request/?utm_campaign=naver_faq'>전체 장례 비용 알아보기</a> | <a href='https://www.goifuneral.co.kr/guide/content/%EC%9E%A5%EB%A1%80%EC%8B%9D%EC%9E%A5/'>오백만원 아끼는 방법</a> 1. 빈소 할인(최대 50%, 사전 예약시에만 적용 가능), 실시간 빈소 현황은 전화로 안내해드립니다. 2. 장례식장 이송, 앰뷸런스 배차 및 필요 서류 안내는 1666-9784를 통해 문의주세요. 3. 미리 온라인으로 전체 장례 비용, 예상 비용 견적을 확인하고 싶으시면 <a href='https://www.goifuneral.co.kr/match/request?utm_campaign=naver_faq'>사전 견적</a>에서 확인해주세요.",
  },
  {
    question: "[장례 비용 확인] 1000만원, 2000만원 넘는 장례 비용이 부담스럽다면?",
    answer:
      "인력, 차량, 용품을 패키지로 이용하세요. 경황없는 상황 속에서 몇백만원짜리 유골함이나 수의를 구매할 필요 없이, 정찰제 패키지를 이용하면 장례 비용을 500만원 이상 아낄 수 있습니다.  <a href='https://www.goifuneral.co.kr/service?utm_campaign=naver_faq'>장례 패키지 전체보기</a> 사전 상담, 사전 견적, 미리 준비할 수 있다면 천만원까지도 아낄 수 있는 것이 장례입니다. 반드시 사전 견적을 확인하고 충분히 상담받으세요 | <a href='https://www.goifuneral.co.kr/match/request?utm_campaign=naver_faq2'>전체 장례비용 견적 받기</a>",
  },
];

const parlorFaqList = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity:
    parlorFaqData.map((item) => {
      return {
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      };
    }) || [],
};

const parlorPricesFaqData = [
  {
    question: "장례 비용/음식 비용을 최대한 줄일 수 있나요? 가족장이란?",
    answer:
      "고이장례연구소(1666-9784)에서는 미사용 품목은 100% 공제해드리며, 품목별 가격 정찰제를 시행중입니다. 장례식장 비용 비교를 통하여 500만원이상 비용을 줄이며, 합리적으로 장례를 치를 수 있게 상담해드립니다. 특히, 음식 비용의 경우 2~300만원의 차이가 나기도 하는데 고이에서 파견한 장례도우미를 통하여 합리적으로 장례를 치를 수 있게 도와드립니다. <a href='https://www.goifuneral.co.kr/match/request/'>전체 비용 알아보기</a>",
  },
  {
    question: "장례지도사가 빈소에 함께하며 장지까지 동행하나요? 빈소를 미리 예약할 수 있나요?",
    answer:
      "빈소는 임종 시점에 이용 가능 여부를 확인해야합니다. 특히 지나치게 큰 빈소를 이용하지 않도록 상담해드리고 염두에 두고 있는 빈소의 비용이나, 주변 장례식장 비용 비교까지 도와드립니다. 장례식장에 연락하여 장례를 진행하는 경우 장례 중 빈소를 잠깐 관리하는 역할을 합니다. 고이의 장례지도사는 장례식장부터 장지, 화장장 예약 등 장례 전반을 책임지며 합리적인 장례를 도와드립니다. 임종 순간부터 장지까지 동행하는 장례지도사, 미리 알아보세요. 고이장례연구소(1666-9784) <a href='https://www.goifuneral.co.kr/review/'>장례지도사 후기 보기</a>",
  },
];

const parlorPricesFaqList = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity:
    parlorPricesFaqData.map((item) => {
      return {
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      };
    }) || [],
};

const reviewResult = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "고이",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    bestRating: "5",
    ratingCount: "178",
  },
  review: [
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "김**",
      },
      reviewBody:
        "언젠가 발생할 제 인생의 다른 상에도 고이와 함께하려고 합니다. 아들이 먼저 갔는데 내가 나이가 많아 어찌해야 할지 막막했는데 최 선생이 멀리서 와서 신경 안 쓰게 알아서 다해주니까 너무 고마웠습니다. ",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "박**",
      },
      reviewBody:
        "장례 경험이 없는 조문객들도 너무 좋으신 분이라고 다른 상조 회사 분들이랑 다르다고 말씀하시더라고요. 할머니가 코로나로 인해 중환자실 2주 계시다 요양병원으로 가신 날 부터 준비를 해야할거같아 그때부터 알아보게 된 곳입니다. 상조가 이미 가입되어있었지만 고이와 비교 해보니 금액적으로 100만원 이상 차이도 났고 사",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "남**",
      },
      reviewBody:
        "고이 장례지도사님을 저희 아버지 장례지도사로 만나게 된 것은 하나님의 마지막 선물인 것 같습니다. 경황도 없고 큰 슬픔에 빠진 저희 가족들에게 하나부터 열까지 진심으로 친절하게 꼼꼼히 챙겨주셨습니다.",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "김**",
      },
      reviewBody:
        "제가 마지막으로 가장 잘한 효도인 것 같네요. 감사했습니다. 갑작스럽게 어머님이 돌아가셔서 정신이 없는 가운데 고이에 전화를 하게되었습니다. 장례 3일동안 오로지 문상객에만 집중할 수 있게 모든 절차나 장지까지 전부 다 알아봐 주시고",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
  ],
};

export const parlorRichSearch = {
  carouselRichSearch,
  howtoRichSearch,
  reviewResult76,
  parlorFaqList,
  parlorPricesFaqList,
  reviewResult,
};
